module.exports = __webpack_public_path__ + "static/media/permission.61512a40.png";